// import 'core-js'
// import 'react-app-polyfill/stable'
// import { createRoot } from 'react-dom/client'
// import { Provider } from 'react-redux'
// import App from './App'
// import store from './store'
// const container = document.getElementById('root')

// const root = createRoot(container) // createRoot(container!) if you use TypeScript
// root.render(
//   <Provider store={store}>
//     <ThemeProvider>
//       <App />
//     </ThemeProvider>
//   </Provider>,
// )

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// NOTE: below code was added when switched to vite from CRA

// CRITICAL: Import React first to ensure it's initialized before Emotion/MUI
// This prevents "Cannot access uninitialized variable" errors in production builds
// The order matters: React must be imported before any components that use Emotion
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { Provider } from 'react-redux'
import { ThemeProvider } from './context/ThemeContext'
import store from './store'
import { loadCSSForRoute } from './utils/cssLoader'

// CRITICAL: Force React module initialization by accessing useInsertionEffect
// This ensures React is fully loaded before any Emotion code tries to access it
// This prevents "Cannot access uninitialized variable" errors in production builds
// when chunks load asynchronously and Emotion chunk might execute before React chunk
// This is a safeguard - accessing the property ensures the module is fully initialized
const _reactInitialized = React && typeof React.useInsertionEffect !== 'undefined' ? React.useInsertionEffect : null

// CRITICAL: Ensure ReactDOM is fully initialized before react-redux tries to access it
// This prevents "Cannot read properties of undefined (reading 'unstable_batchedUpdates')" errors
// React 18 doesn't have unstable_batchedUpdates, but react-redux should handle this gracefully
// However, we need to ensure ReactDOM is loaded before react-redux executes
// Accessing ReactDOM.createRoot ensures the module is fully initialized
if (typeof ReactDOM === 'undefined' || typeof ReactDOM.createRoot === 'undefined') {
  throw new Error('ReactDOM is not properly initialized')
}

// import 'core-js'
// import 'react-app-polyfill/stable'

// Hide initial loader once React has rendered AND app data is loaded
// Use multiple strategies to ensure it works
function hideInitialLoader() {
  const loader = document.getElementById('initial-loader')
  if (loader) {
    loader.classList.add('hidden')
    if (document.body) {
      document.body.classList.add('react-loaded')
    }
  }
}

// Function to check if app is ready (React mounted + data loaded)
function checkAppReady() {
  const root = document.getElementById('root')
  const hasReactContent = root && root.children.length > 0
  
  // Check if we're past the initial loading phase
  // Look for any React content in the root
  if (hasReactContent) {
    // Hide loader immediately when React mounts - no artificial delay
    hideInitialLoader()
    return true
  }
  return false
}

async function bootstrapApp() {
  try {
    await loadCSSForRoute(window.location.pathname || '/')
  } catch (error) {
    console.warn('[main] Failed to preload route-specific CSS:', error)
  }

  const root = ReactDOM.createRoot(document.getElementById('root'))
  root.render(
    // <React.StrictMode>
      <Provider store={store}>
        <ThemeProvider>
          <div className="Root">
            <App />
          </div>
        </ThemeProvider>
      </Provider>
    // </React.StrictMode>,
  )

  // Hide after React has had time to render
  // Use single requestAnimationFrame for faster detection (removed nested frame for speed)
  requestAnimationFrame(() => {
    // Check immediately first
    if (!checkAppReady()) {
      // Keep checking periodically until app is ready (faster interval for quicker detection)
      const checkInterval = setInterval(() => {
        if (checkAppReady()) {
          clearInterval(checkInterval)
        }
      }, 50) // Reduced from 100ms to 50ms for faster detection

      // Fallback: hide after 5 seconds max
      setTimeout(() => {
        clearInterval(checkInterval)
        hideInitialLoader()
      }, 5000)
    }
  })
}

bootstrapApp()
